module.exports = __webpack_public_path__ + "static/yazan-name-logo-b44ef6800afe89c7b988e28ce31522a3.png";